import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import CategoryPage from "@/pages/category/page";
import SearchPage from "@/pages/search/page";
import BlacklistPage from "@/pages/blacklist/page";
import DetailPage from "@/pages/detail/page";
import AboutPage from "@/pages/about/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/category/:categoryId",
    element: <CategoryPage />,
  },
  {
    path: "/search",
    element: <SearchPage />,
  },
  {
    path: "/blacklist",
    element: <BlacklistPage />,
  },
  {
    path: "/detail/:eventId",
    element: <DetailPage />,
  },
  {
    path: "/about",
    element: <AboutPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;